import { createApp } from 'vue'
import App from './App.vue'
import 'tailwindcss/tailwind.css'
import './assets/tailwind.css'

createApp(App).mount('#app')
